module.exports = "https://la-static.vkplay.ru/promo/thefirst/img/rating-header-silver.26a300bb.png";